module.exports = __webpack_public_path__ + "static/media/icon_109.9ba01a61.svg";